import * as React from "react";
import { useState } from "react";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import SuggestionsList from "components/common/EntityFilters/FilterConfiguration/SuggestionsList";
import useTableFilterContext from "components/common/PaginatedEntityTable/useTableFilterContext";
import { slicesToFilters } from "components/common/PaginatedEntityTable/useFetchEntities";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
import { fetchAssetFilterValues } from "security-app/hooks/api/assetsAPI";
import { assetsQueryKey } from "security-app/hooks/queryKeys";
const DEFAULT_SEARCH_PARAMS = {
  query: "",
  pageSize: 10,
  page: 1
};
const AssetFilterValuesFilter = ({
  attribute,
  allActiveFilters,
  filter = void 0,
  filterValueRenderer,
  onSubmit
}) => {
  var _a, _b;
  const [searchParams, setSearchParams] = useState(DEFAULT_SEARCH_PARAMS);
  const { searchParams: tableSearchParams } = useTableFilterContext();
  const { query: tableQuery, filters: tableFilters } = slicesToFilters(tableSearchParams);
  const valueSearchParams = {
    valueQuery: searchParams.query,
    page: searchParams.page,
    pageSize: searchParams.pageSize
  };
  const { data, isInitialLoading } = useQuery({
    queryKey: assetsQueryKey("filter-values", attribute.id, valueSearchParams, tableQuery, tableFilters),
    queryFn: () => defaultOnError(
      fetchAssetFilterValues(attribute.id, valueSearchParams, tableQuery, tableFilters),
      i18n.t("notifications.fetch_asset_filter_values_failed", {
        ns: "enterprise_security_assets",
        attribute: attribute.title.toLowerCase()
      }),
      i18n.t("notifications.could_not_retrieve_asset_filter_values", {
        ns: "enterprise_security_assets",
        attribute: attribute.title.toLowerCase()
      })
    ),
    placeholderData: keepPreviousData
  });
  return /* @__PURE__ */ React.createElement(
    SuggestionsList,
    {
      allActiveFilters,
      attribute,
      multiSelect: !filter,
      filterValueRenderer,
      onSubmit,
      suggestions: (_a = data == null ? void 0 : data.suggestions) != null ? _a : [],
      isLoading: isInitialLoading,
      total: (_b = data == null ? void 0 : data.pagination.total) != null ? _b : 0,
      page: searchParams.page,
      pageSize: searchParams.pageSize,
      setSearchParams
    }
  );
};
export default AssetFilterValuesFilter;
